/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSidebar = {
  init() {
    document.querySelectorAll('[data-faceted-filter-form]').forEach(facetedFilterForm => {
      if (facetedFilterForm.dataset.filtersBound) return;
      facetedFilterForm.dataset.filtersBound = 'true';
      const applyFilters = event => {
        if (event.type === 'change' && event.target.type === 'number') return;
        event.preventDefault();
        const destination = new URL(window.location.href);
        // A new filter starts at page one while preserving sort, locale, and preview state.
        Array.from(destination.searchParams.keys()).forEach(key => {
          if (key.startsWith('filter.') || key === 'page') destination.searchParams.delete(key);
        });
        new FormData(facetedFilterForm).forEach((value, key) => {
          if (value === '') return;
          if (key.startsWith('filter.')) destination.searchParams.append(key, value);
          else destination.searchParams.set(key, value);
        });
        window.location.assign(destination.toString());
      };
      facetedFilterForm.addEventListener('change', applyFilters);
      facetedFilterForm.addEventListener('submit', applyFilters);
      facetedFilterForm.querySelectorAll('a.faceted-active-filters__clear').forEach(link => {
        const destination = new URL(window.location.href);
        Array.from(destination.searchParams.keys()).forEach(key => {
          if (key.startsWith('filter.') || key === 'page') destination.searchParams.delete(key);
        });
        link.href = destination.toString();
      });
    });

    const openSidebarBlocks = document.querySelectorAll('[data-sidebar-block__toggle="open"]');

    openSidebarBlocks.forEach(block => {
      window.PXUTheme.jsSidebar.openSidebarBlock($(block));
    });

    // eslint-disable-next-line func-names
    $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="closed"]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsSidebar.openSidebarBlock($(this));
    });

    // eslint-disable-next-line func-names
    $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="open"]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsSidebar.closeSidebarBlock($(this));
    });

    if ($('[data-product-sidebar]').length) {
      $('.section--has-sidebar-option').addClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').removeClass('has-sidebar-disabled');
    } else {
      $('.section--has-sidebar-option').removeClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').addClass('has-sidebar-disabled');
    }
  },
  openSidebarBlock($toggleBtn) {
    const $parentBlock = $toggleBtn.closest('.sidebar__block');

    $toggleBtn.attr('data-sidebar-block__toggle', 'open');

    $parentBlock.addClass('is-active');
    $parentBlock.attr('aria-expanded', true);
    $parentBlock.find('[data-sidebar-block__content--collapsible]').slideDown();
  },
  closeSidebarBlock($toggleBtn) {
    const $parentBlock = $toggleBtn.closest('.sidebar__block');

    $toggleBtn.attr('data-sidebar-block__toggle', 'closed');

    $parentBlock.removeClass('is-active');
    $parentBlock.attr('aria-expanded', false);
    $parentBlock.find('[data-sidebar-block__content--collapsible]').slideUp();
  },
  unload() {
    const $toggleBtn = $('[data-sidebar-block__toggle]');
    $toggleBtn.off();
  },
};

/******/ })()
;
